export default __webpack_public_path__ + "static/media/svg3.b30e1bed.svg";